export enum DateFilter {
  Last7Days = "Last7Days",
  Last30Days = "Last30Days",
  Last90Days = "Last90Days",
  AllTime = "AllTime",
}
